<template>
  <div class="p-6 role-form">
    <form @submit.prevent="handleSubmit">
      <div class="vx-row">
        <div class="w-full mb-6 vx-col">
          <vs-input
            readonly
            v-model="formData.name"
            class="w-full"
            label="Name"
            :danger="!!errors.name"
            :danger-text="errors.name"
          />
        </div>

        <div class="w-full mb-6 vx-col">
          <vs-input
            readonly
            v-model="formData.emailAddress"
            label="Email"
            class="w-full"
            :danger="!!errors.emailAddress"
            :danger-text="errors.emailAddress"
          />
        </div>

        <div class="w-full mb-6 vx-col">
          <label class="block mb-2">Roles</label>
          <div class="flex flex-wrap gap-2">
            <vs-chip
              v-for="role in availableRoles"
              :key="role.id"
              :color="isRoleSelected(role) ? 'primary' : 'default'"
              @click.native="toggleRole(role)"
              class="mr-2 cursor-pointer"
            >
              {{ role.name }}
            </vs-chip>
          </div>
          <span v-if="errors.roleIds" class="text-sm text-danger">
            {{ errors.roleIds }}
          </span>
        </div>

        <!-- Display Permissions -->
        <div v-if="selectedRolePermissions?.length > 0" class="mt-4">
          <h3 class="font-bold">Permissions for Selected Role:</h3>
          <ul>
            <li
              v-for="(permission, index) in selectedRolePermissions"
              :key="index"
            >
              {{ permission.permission.name }} <br />
            </li>
          </ul>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="flex justify-end mt-6">
        <vs-button
          type="button"
          color="grey"
          class="mr-4"
          @click="$emit('cancel')"
        >
          Cancel
        </vs-button>
        <vs-button @click="handleSubmit" :disabled="isSubmitting">
          Update User Role
        </vs-button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    userData: Object,
    isEditing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: {
        id: this.userData ? this.userData.id : null,
        name: this.userData ? this.userData.name : '',
        emailAddress: this.userData ? this.userData.emailAddress : '',
        roleIds: [], // Changed from roleId to roleIds array
      },
      selectedRolePermissions: [],
      errors: {
        name: '',
        description: '',
        permissions: '',
      },
      isSubmitting: false,
    }
  },

  computed: {
    availableRoles() {
      return this.$store.state.role.roles || []
    },
  },

  watch: {
    userData: {
      handler(newValue) {
        this.formData = {
          id: this.userData?.id,
          name: this.userData?.name,
          emailAddress: this.userData?.emailAddress,
          roleIds: newValue?.userRoles?.map((ur) => ur.roleId) || [], // Updated to handle multiple roles
        }
      },
      immediate: true,
    },
  },

  methods: {
    isRoleSelected(role) {
      return this.formData.roleIds.includes(role.id)
    },

    toggleRole(role) {
      if (this.isRoleSelected(role)) {
        this.formData.roleIds = this.formData.roleIds.filter(
          (id) => id !== role.id
        )
      } else {
        this.formData.roleIds.push(role.id)
      }
      this.updatePermissions()
    },
    updatePermissions() {
      const selectedRoles = this.availableRoles.filter((role) =>
        this.formData.roleIds.includes(role.id)
      )

      this.selectedRolePermissions = selectedRoles.flatMap(
        (role) => role.rolePermissions || []
      )
    },
    async handleSubmit() {
      this.isSubmitting = true
      try {
        const payload = {
          id: this.userData.id,
          name: this.userData.name,
          description: this.userData.description,
          emailAddress: this.userData?.emailAddress,
          roleIds: this.formData.roleIds,
        }
        await this.$emit('submit', payload)
      } catch (error) {
        console.error('Form submission error:', error)
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.role-form {
  max-width: 800px;
  margin: 0 auto;
}

.permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 0.5rem;
}

.text-danger {
  color: rgba(var(--vs-danger), 1);
}
</style>
